export default {
  女装: "女性の服装",
  男装: "男性用",
  手机和小工具: "携帯電話とガジェット",
  居家生活: "家庭生活",
  电脑及周边设备: "コンピュータおよび周辺機器",
  美容及个人护理: "美容とパーソナルケア",
  家用电器: "家庭用器具",
  健康与保健: "健康とウェルネス",
  食品和饮料: "食べ物や飲み物",
  玩具_儿童和婴儿: "おもちゃ、子供、赤ちゃん",
  童装时尚: "子供のファッション",
  视频游戏: "ビデオゲーム",
  运动与户外: "スポーツとアウトドア",
  爱好与书籍: "趣味と本",
  相机和无人机: "カメラとドローン",
  宠物食品及用品: "ペットフードとペット用品",
  女士包袋: "女性のバッグ",
  男士包袋: "メンズバッグ",
  珠宝及配饰: "ジュエリーとアクセサリー",
  手表: "時計",
  女鞋: "女性の靴",
  男装鞋: "メンズシューズ",
  汽车: "車",
  我附近的ShopeePay: "近くのShopeePay",
  餐饮_旅行和服务: "ケータリング、旅行、サービス",
  旅行及行李: "旅行と荷物",
  各种各样的: "異なる種類",
  我是来买什么的: "私は何を買うためにここにいるのですか？",
  对不起_找不到_相关的商品:
    "申し訳ありませんが、[{0}] に関連する商品は見つかりませんでした",
  类别: "カテゴリー",
  产品: "製品",
  店铺: "店",
  首页: "表紙",
  限时秒杀: "期間限定フラッシュセール",
  博客: "ブログ",
  所有品牌: "すべてのブランド",
  所有类别: "すべてのカテゴリ",
  我的购物车: "私のショッピングカート",
  发货信息: "配送に関する情報",
  交货信息: "配送に関する情報",
  付款: "支払い",
  确认: "確認する",
  您的购物车是空的: "ショッピングカートは空です",
  价格: "価格",
  税: "税",
  数量: "量",
  总计: "合計",
  移除: "取り除く",
  返回商店: "ストアに戻る",
  继续发货: "出荷を続ける",
  筛选: "フィルター",
  价格范围: "価格帯",
  排序方式: "並べ替え",
  最新: "最新の",
  最旧: "最古の",
  价格从低到高: "価格が安いものから高いものまで",
  价格从高到低: "価格が高いものから安いものまで",
  选择交货类型: "配送タイプを選択してください",
  送货上门: "配達",
  继续付款: "支払いを続ける",
  任何其他信息: "その他の情報",
  或者: "または",
  您的钱包余额: "ウォレットの残高",
  余额不足: "残高不足",
  支付: "支払う",
  我同意: "同意します",
  条款和条件: "利用規約",
  退货政策: "返品規則",
  隐私政策: "プライバシーポリシー",
  概括: "一般化する",
  项目: "プロジェクト",
  全部的: "全て",
  小计: "小計",
  总运费: "合計送料",
  有优惠码吗_在这里输入: "割引コードはありますか? ここに入力",
  申请: "適用する",
  编辑: "編集",
  删除: "消去",
  添加新地址: "新しいアドレスを追加",
  继续交货信息: "引き続き配信情報",
  选择一个地址: "住所を選択してください",
  购买历史: "購入履歴",
  下载: "ダウンロード",
  已发送退款请求: "返金リクエストを送信しました",
  对比: "比較した",
  对话: "対話",
  我的钱包: "私の財布",
  工单: "作業命令",
  管理个人资料: "プロフィールの管理",
  登出: "サインアウト",
  重置对比列表: "比較リストをリセット",
  您的对比列表为空: "比較リストが空です",
  在您的购物车中: "ショッピングカートの中に",
  在您的愿望清单中: "あなたのウィッシュリストに",
  在您的预定列表中: "予約リストにある",
  下载您的产品: "製品をダウンロードする",
  选项: "オプション",
  什么都没找到: "何も見つかりません",
  特色产品: "おすすめ商品",
  最畅销: "ベストセラー",
  前_名: "トップ{0}",
  查看更多: "続きを見る",
  查看所有类别: "すべてのカテゴリを表示",
  十大品牌: "トップ10ブランド",
  查看所有品牌: "すべてのブランドを見る",
  登录: "ログイン",
  手机号码: "電話番号",
  密码: "パスワード",
  密码长度为6到16个字符: "パスワードの長さは6～16文字です",
  验证码: "検証コード",
  登录中: "ログイン",
  游客登录: "訪問者ログイン",
  注册您的商店: "ストアを登録する",
  现在申请: "今すぐお申し込みください",
  成为商家: "商人になる",
  现在注册: "今すぐ登録",
  登录成功: "無事着陸しました",
  通知: "通知する",
  未找到通知: "通知が見つかりません",
  评论: "コメント",
  估计运输时间: "発送予定時間",
  天: "空",
  所售: "売られた",
  给商家留言: "販売者にメッセージを残す",
  规格: "仕様",
  库存: "在庫あり",
  总价: "合計金額",
  添加到购物车: "カートに追加",
  立即购买: "即購入",
  缺货: "在庫切れ",
  添加到愿望清单: "ほしい物リストに追加する",
  加入对比列表: "比較リストに追加",
  退款: "返金",
  查看条款: "規約を見る",
  分享: "共有",
  描述: "説明する",
  相关产品: "関連製品",
  没有人问过商家: "誰も商人に尋ねなかった",
  该产品暂无评论: "この商品にはまだレビューがありません",
  客户评论: "カスタマーレビュー",
  访问商店: "ストアを訪問する",
  畅销产品: "ベストセラー",
  日期: "日付",
  订单编号: "注文番号",
  总额: "一時金",
  状态: "州",
  愿望清单: "ウィッシュリスト",
  还没有添加任何东西: "まだ何も追加されていません",
  注册: "登録する",
  邀请码: "招待コード",
  请输入邀请码: "招待コードを入力してください",
  用户名: "ユーザー名",
  请输入用户名: "ユーザー名を入力してください",
  用户名长度为6_14个字符: "ユーザー名の長さは 6 ～ 14 文字です",
  昵称: "ニックネーム",
  请输入手机号码: "電話番号を入力してください",
  手机号码格式错误: "電話番号の形式が間違っています",
  密码长度为6_16个字符: "パスワードの長さは 6 ～ 16 文字です",
  确认密码: "パスワードを認証する",
  请输入确认密码: "確認用のパスワードを入力してください",
  提款密码: "出金パスワード",
  请输入提款密码: "出金パスワードを入力してください",
  提款密码长度为4_16个字符: "出金パスワードの長さは 4 ～ 16 文字です",
  请输入验证码: "確認コードを入力してください",
  在_s后发送: "{0}秒後に送信",
  发送验证码: "確認コードを送信する",
  注册即表示您同意我们的条款和条件:
    "サインアップすると、利用規約に同意したことになります。",
  创建账号: "アカウントを作成する",
  验证码发送成功: "確認コードが正常に送信されました",
  确认密码不一致: "パスワードが一致していないことを確認する",
  提款密码必须为数字: "出金パスワードは数字でなければなりません",
  注册成功: "登録完了",
  购物车: "ショッピングカート",
  账户: "アカウント",
  我的账户: "私のアカウント",
  已经有一个账户: "すでにアカウントをお持ちですか",
  新地址: "新しいアドレス",
  编辑地址: "住所の編集",
  保存: "保存",
  是否默认: "デフォルトですか",
  具体地址: "特定の住所",
  请输入具体地址: "特定の住所を入力してください",
  地区: "エリア",
  请输入地区: "地域を入力してください",
  城市: "市",
  请输入城市: "市区町村を入力してください",
  省份: "州",
  请输入省份: "都道府県を入力してください",
  邮政编码: "郵便番号",
  请输入邮政编码: "郵便番号を入力してください",
  电话号码: "電話番号",
  请输入电话号码: "電話番号を入力してください",
  收货人: "受信機",
  请输入收货人: "荷受人を入力してください",
  保存成功: "正常に保存",
  最畅销的商家: "ベストセラー販売業者",
  查看所有的商家: "すべてのビジネスを見る",
  支持政策: "サポートポリシー",
  您的电子邮件地址: "あなたのメールアドレス",
  订阅: "サブスクリプション",
  联系方式: "連絡先",
  地址: "住所",
  美国伊利诺伊州霍夫曼庄园: "ホフマン エステーツ、イリノイ州、米国",
  快速链接: "クイックリンク",
  商家政策: "販売者のポリシー",
  submit: "提出する",
  提款银行卡: "銀行カードの引き出し",
  我的面板: "私のパネル",
  提示: "ヒント",
  确定登出吗: "ログアウトしてもよろしいですか?",
  确定: "もちろん",
  取消: "キャンセル",
  项目添加到您的购物车: "ショッピングカートに商品を追加します",
  经常一起购买: "一緒に買うことが多い",
  返回购物: "ショッピングに戻る",
  进行结算: "チェックアウトに進む",
  帮助热线: "ヘルプライン",
  查看所有通知: "すべての通知を表示",
  请输入密码: "パスワードを入力してください",
  前往充值: "充電に行く",
  购物车物品: "ショッピングカートの商品",
  查看购物车: "ショッピングカートを確認してください",
  钱包余额: "ウォレット残高",
  充值钱包: "ウォレットにリチャージ",
  钱包充值_线下_: "ウォレットへのリチャージ（オフライン）",
  申请提款: "退会申請をする",
  钱包收支明细: "ウォレットの収入と支出の詳細",
  批准: "承認する",
  提现历史记录: "出金履歴",
  类型: "タイプ",
  信息: "情報",
  付款方式: "支払方法",
  请选择付款方式: "お支払い方法を選択してください",
  Bill_Type_RECHARGE_BACK: "バックエンドのリチャージ",
  Bill_Type_RECHARGE_ONLINE: "オンラインリチャージ",
  Bill_Type_RECHARGE_REGISTER: "無料で登録してください",
  Bill_Type_RECHARGE_JACKPOT: "リチャージボーナス",
  Bill_Type_RECHARGE_PRESENT: "リチャージ報酬",
  Bill_Type_RECHARGE_FROM_COMMISSION: "コミッションの送金",
  Bill_Type_RECHARGE_TG_COMMISSION: "リチャージ促進手数料",
  Bill_Type_REGISTER_TG_COMMISSION: "登録促進手数料",
  Bill_Type_WITHDRAW: "撤回する",
  Bill_Type_WITHDRAW_REJECT: "出金が拒否されました",
  Bill_Type_DEDUCT_HANDLE: "手動控除",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "リチャージ補正",
  Bill_Type_MINING_PROFIT: "鉱業収入",
  Bill_Type_MINING_PROFIT_COMMISSION: "鉱業収入促進手数料",
  Bill_Type_VIP_UPGRADE: "アップグレードVIP",
  Bill_Type_FINANCE_BUY: "金融商品を購入する",
  Bill_Type_FINANCE_CAPITAL_RETURN: "財務残高の返還",
  Bill_Type_FINANCE_FEE: "財務管理手数料",
  Bill_Type_FINANCE_PROFIT: "財務管理収入",
  Bill_Type_FINANCE_BUY_COMMISSION: "金融商品購入手数料",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "金融商品収入手数料",
  Bill_Type_WHEEL_DRAW: "大車輪宝くじ",
  Bill_Type_BUY: "商品を買う",
  Bill_Type_PAY_SHOP: "送料を支払う",
  Bill_Type_BUY_COMMISSION: "購入した商品に対する手数料",
  Bill_Type_DEPOSIT: "デポジットを支払う",
  Bill_Type_STORE_BUY: "商品を買う",
  Bill_Type_STORE_BUY_REFUND: "購入商品の返金",
  Bill_Type: "アカウント変更タイプ",
  Before_Money: "以前の金額",
  Deal_Money: "口座変更金額",
  After_Money: "後の金額",
  Bill_Time: "アカウント変更時期",
  No_More_Data: "もうデータはありません",
  Apply_Money: "申請金額",
  Apply_Time: "申請時間",
  Withdraw_Info: "手数料: {fee}、到着: {money}",
  提款订单状态_CHECKING: "審査待ち",
  提款订单状态_TRANSFERRING: "転送中",
  提款订单状态_PASS: "確認済み",
  提款订单状态_REJECT: "解雇された",
  暂无可用充值方式: "まだ利用可能な充電方法はありません",
  钱包收款码: "ウォレットの支払いコード",
  钱包地址: "ウォレットアドレス",
  金额限制: "金額制限",
  复制: "コピー",
  付款凭证: "支払い伝票",
  收款银行: "受取銀行",
  收款人: "受取人",
  收款账号: "支払い口座番号",
  付款银行: "支払い銀行",
  付款人: "支払者",
  付款账号: "支払い口座",
  请输入付款银行: "お支払い銀行を入力してください",
  请输入付款人: "支払者を入力してください",
  请输入付款账号: "お支払い口座番号を入力してください",
  请上传付款凭证: "支払い伝票をアップロードしてください",
  充值金额: "チャージ金額",
  请输入充值金额: "チャージ金額を入力してください",
  submitting: "提出中...",
  Confirm: "提出する",
  Commit_Success: "正常に送信されました",
  balanceType_BALANCE: "バランス",
  balanceType_COMMISSION: "手数料",
  Balance: "勘定残高",
  Wash_Money: "打码",
  请选择银行账户: "銀行口座を選択してください",
  卡号类型: "カード番号の種類",
  提现金额: "出金金額",
  提款金额: "出金額",
  不能为空: "空にすることはできません",
  金额不正确: "金額が間違っています",
  please_input_withdraw_password: "出金パスワードを入力してください",
  withdraw_password_format_error:
    "出金パスワードは4～16文字である必要があります",
  Fee: "手数料",
  实际到账: "実際の到着",
  交易币种: "取引通貨",
  原始密码: "元のパスワード",
  confirm_password_error: "2回入力したパスワードが間違っています",
  save_success: "正常に保存",
  please_input: "入ってください",
  old_password: "以前のパスワード",
  new_password: "新しいパスワード",
  please_input_confirm_password: "パスワードをもう一度確認してください",
  没有找到符合条件的商品: "一致する商品が見つかりませんでした",
  Search: "検索",
  全部: "全て",
  EnumGoodsOrderState_USER_PAY: "配達待ち",
  EnumGoodsOrderState_SHOP_PAY: "配達中",
  EnumGoodsOrderState_SUCCESS: "仕上げる",
  EnumGoodsOrderState_CANCEL: "キャンセル",
  EnumGoodsOrderState_REFUND_SUCCESS: "返金された",
  订单号: "注文番号",
  用户名称: "ユーザー名",
  收益: "所得",
  支付时间: "支払い時期",
  配送时间: "納期",
  完成时间: "完了時間",
  发货: "船",
  全选: "すべて選択",
  物品已添加到愿望清单: "商品がウィッシュリストに追加されました",
  物品已添加到比较列表: "比較リストに項目を追加しました",
  购买成功提示: "おめでとうございます。購入は成功しました",
  订单列表: "オーダーリスト",
  商品名: "商品名",
  图片: "写真",
  没有品牌: "ノーブランド",
  基本信息: "基本情報",
  Account_Name: "口座開設名",
  Bank_Account: "銀行口座",
  Bank_Phone: "携帯電話番号を予約する",
  IFSC: "IFSCアカウント",
  UPI: "UPIアカウント",
  PIX: "PIXアカウント",
  CPF: "CPFアカウント",
  GCASH: "GCASHアカウント",
  POWWI: "パウウィアカウント",
  身份证号: "ID番号",
  Edit: "改訂",
  Delete: "消去",
  Add: "新しい",
  Forget_Withdraw_Password: "出金パスワードを忘れた場合",
  Bank_Card_Info: "銀行カード情報",
  收款人地址: "受取人の住所",
  SWIFT: "迅速",
  Bank_Branch: "支店名",
  分行代码: "支店コード",
  银行地址: "銀行住所",
  Email: "Eメール",
  银行卡长度必须超过: "銀行カードの長さは {length} を超える必要があります",
  银行卡格式不正确: "銀行カードの形式が正しくありません",
  Do_you_confirm_delete: "削除を確認しますか?",
  Please_Login_First: "まずログインしてください",
  Bank_Name: "銀行名",
  Please_add_bank_first:
    "銀行カードをまだバインドしていません。最初に追加してください。",
  withdrawType: "出金タイプ",
  withdraw_money_limit:
    "出金額は 0 より大きく、{balance} 以下である必要があります",
  withdraw_times_limit:
    "本日 {todayWithdrawNum} 回出金しましたが、{limitTimes} 回を超えると {withdrawFee}% の手数料が請求されます。 本当に撤退しますか？",
  Copy_Success: "正常にコピーされました",
  商店首页: "店舗ホームページ",
  所有产品: "すべての製品",
  新到货产品: "新着商品",
  所有商家: "すべての販売者",
  请上传: "アップロードしてください",
  请输入: "入ってください",
  忘记密码: "パスワードを忘れる",
  记得我: "私を覚えてますか",
  共_件: "合計 {0} 個のアイテム",
  取消订单: "注文をキャンセルする",
  申请退款: "返金をリクエストする",
  未知商家: "不明な商人",
  到账: "レシート",
  提款订单状态: "出金注文ステータス",
  前_名类别: "上位 {0} カテゴリ",
  取消订单原因_不想要了: "もういらない",
  取消订单原因_商品错选_多选: "製品の選択間違い/複数選択",
  取消订单原因_商品无货: "在庫切れの商品",
  取消订单原因_地址信息填写错误: "住所情報が間違って入力されている",
  取消订单原因_商品降价: "製品の値下げ",
  取消订单原因_价格高于其他平台: "他のプラットフォームに比べて価格が高い",
  取消订单原因_没用_少用_错用优惠: "無駄な割引/あまり使用しない/誤用の割引",
  退款原因_拍错_多拍_不喜欢: "間違ったショット / 余分なショット / 気に入らない",
  退款原因_商品成分描述不符: "製品の成分説明が一致しません",
  退款原因_与商家协商一致退款: "販売者との合意に基づく返金",
  退款原因_生产日期_保质期与商品描述不符:
    "製造日/賞味期限が商品説明と一致しません",
  退款原因_图片_产地_批号_规格等描述不符:
    "写真/原産地/バッチ番号/仕様およびその他の説明が一致しません",
  退款原因_质量问题: "品質問題",
  退款原因_商品变质_发霉_有异物:
    "商品が腐っている・カビが生えている・異物が入っている",
  退款原因_少件_含缺少配件_: "数点（付属品欠品含む）",
  退款原因_收到商品时有破损_污渍_变形:
    "受け取った時点で商品が破損/汚れ/変形していた。",
  退款原因_假冒品牌: "偽造ブランド",
  退款原因_发票问题: "請求書の問題",
  退款原因_商家发错货: "販売者は間違った商品を送った",
  退款原因_预约不到_商家不给退换:
    "予約が取れない・返品・交換を受け付けてくれない",
  退款失败: "返金に失敗しました",
  退款处理中: "返金中です",
  默认: "デフォルト",
  产品查询: "製品検索",
  商店LOGO: "ストアロゴ",
  推广码: "販売促進コード",
  查看所有: "すべて見る",
  确认收货成功: "商品の受領を無事に確認",
  物流公司: "物流会社",
  物流单号: "出荷番号",
  发货时间: "輸送時間",
  请先选择商品规格: "最初に製品仕様を選択してください",
  个人信息: "個人情報",
  您的用户名: "あなたのユーザーネーム",
  你的名字: "あなたの名前",
  登录名: "ユーザー名",
  你的邮件: "あなたのメールアドレス",
  你的密码: "あなたのパスワード",
  重复输入密码: "パスワードを再度入力してください。",
  店铺名称: "店名",
  证书类型: "証明書の種類",
  身份证: "IDカード",
  护照: "パスポート",
  驾驶执照: "運転免許証",
  社会保障卡: "社会保障カード",
  证书正面: "証明書の表面",
  证书反面: "証明書裏面",
  确认收货: "商品の受領を確認する",
  请选择取消订单的原因必选:
    "注文をキャンセルする理由を選択してください (必須):",
  请选择申请退款的原因必选:
    "返金をリクエストする理由を選択してください (必須):",
  留言: "メッセージ",
  请输入留言: "メッセージを入力してください",
  没有帐户: "アカウントがありません",
  钱包充值: "ウォレットのリチャージ",
  输入您的文字: "テキストを入力してください",
  商家登录: "販売者のログイン",
  有关此产品的任何查询: "この商品に関するお問い合わせは",
  产品名称: "商品名",
  你的问题: "あなたの問題",
  白银店铺: "シルバーショップ",
  铂金店铺: "プラチナストア",
  钻石店铺: "ダイヤモンドショップ",
  照片: "写真",
  已退货: "戻ってきた",
  邮寄状态: "郵送状況",
  订单摘要: "注文の概要",
  收件地址: "受信者のアドレス",
  订购日期: "注文日",
  订单状态: "注文の状況",
  总订单金额: "注文総額",
  邮寄方式: "郵送方法",
  附加信息: "追加情報",
  订单详细信息: "注文詳細",
  交货类型: "配送タイプ",
  进行评论: "コメントをする",
  已评论: "コメント付き",
  订单金额: "注文金額",
  优惠券: "クーポン",
  统一运费: "一律送料",
  送货地址: "お届け先の住所",
  评分: "スコア",
  你的意见: "あなたの意見",
  匿名: "匿名",
  现金: "現金",
  详情: "詳細",
  收货地址: "お届け先の住所",
  暂时没有对话: "まだ会話はありません",
  你: "あなた",
  输入您的回复: "返信を入力してください",
  删除成功: "正常に削除されました",
  品牌: "ブランド",
  已缴纳的保证金: "保証金の支払い済み",
  黄金店铺: "ゴールドストア",
  没有更多数据: "もうデータはありません",
  站内信: "サイトメッセージ",
  系统通知: "システム通知",
  邮箱: "郵便",
  手机号: "電話番号",
  你的手机号: "あなたの電話番号",
  营业执照: "営業許可証",
  你的邮箱: "あなたのメールボックス",
  搜索结果: "の検索結果",
  系统公告: "システム通知",
  加入对比: "比較に追加",
  佣金余额: "手数料残高",
  刷新: "リフレッシュする",
  刷新成功: "更新に成功しました",
  官网: "公式ウェブサイト",
  税号: "納税者番号",
  订单: "注文",
  合计: "合計",
  系统安全: "システムセキュリティ",
  Recharge_Money_Limit:
    "リチャージ金額は {min} から {max} までである必要があります",
  限时优惠: "期間限定オファー",
  高价回收: "高価リサイクル",
  姓名: "名前",
  商品订单号: "製品注文番号",
  商品在线回收: "製品のオンラインリサイクル",
  提交: "提出する",
  回收记录: "リサイクル記録",
  回收状态: "リサイクル状況",
  回收价格: "リサイクル価格",
  纳税码: "税法",
  买家登录: "ログイン",
  买家注册: "登録する",
  语言: "日语",
  客服: "顧客サービス",
  消息已撤回: "ニュースは撤回されました",
  物流详情: "ロジスティクスの詳細",
  充值: "補充します",
  提现: "撤回する",
  信用分: "クレジット",
  余额: "バランス",
  佣金: "手数料",
  继续购物: "買い物を続けます",
  订单结算: "和解を注文します",
  language: "中国語",
  助力提示:
    "商人を支援することで、プラットフォームの店舗への露出を増やすことができ、累積日数が高いほど、露出が高くなります。",
  已累计助力: "累積的に支援されます",
  今日已助力: "今日は助けてくれました",
  立即助力: "すぐに助けてください",
  商家助力: "商人の助け",
  证件号码: "ID番号",
  证书号码: "証明書番号",
  男鞋: "男子靴",
  游戏玩具: "ゲームのおもちゃ",
  使用条款: "利用規約",
  商家: "商人",
  已助力: "助けました",
  被助力: "助けられている",
  用户: "ユーザー",
  助力记录: "記録に役立ちます",
  消息类型: "メッセージタイプ",
  消息内容: "メッセージコンテンツ",
  链接: "リンク",
  文本: "文章",
  清空: "クリア",
  评论成功: "コメント成功",
  扫描二维码: "QRコードをスキャンしてください",
  转入: "転入",
  收款: "コレクション",
  任务下单中心: "タスクオーダーセンター",
  记录: "記録する",
  任务倒计时: "タスクのカウントダウン",
  倒计时后自动放弃: "カウントダウン後に自動的に諦める",
  业务码: "事業者コード",
  选择商品分类: "製品カテゴリを選択してください",
  可多选: "複数選択可能",
  加载分类中: "カテゴリを読み込んでいます",
  暂无分类: "まだ分類されていません",
  产品类别: "製品カテゴリー",
  账户余额: "口座残高",
  立即结算: "即時決済",
  任务已自动放弃: "タスクは自動的に放棄されました",
  商品分类: "製品分類",
  订单详情: "注文の詳細",
  预计收益: "推定収益",
  预计佣金收益: "推定手数料収入",
  收益率: "収量",
  扣款账户: "借方口座",
  确认结算: "決済の確認",
  未选择: "未選択",
  请选择商品分类: "製品カテゴリを選択してください",
  下单成功: "注文は正常に完了しました",
  下单失败: "注文に失敗しました",
  请重试: "もう一度試してください",
  订单记录: "注文履歴",
  没有更多了: "もうだめ",
  业务号: "事業者番号",
  商品类型: "製品タイプ",
  佣金收益: "手数料収入",
  待结算: "決済保留中",
  已结算: "決済済み",
  已取消: "キャンセルされました",
  加载失败: "読み込みに失敗しました",
  倒计时: "カウントダウン",
  随机商品: "ランダムアイテム",
  为: "のために",
  商户助力可提升商品曝光度: "販売者のサポートにより商品の露出が増加します",
  累计助力越高推荐权重越高:
    "蓄積された支援が多いほど、推奨の重みが高くなります。",
  实时助力动态: "リアルタイムの支援ダイナミクス",
  助力奖励: "ブースト報酬",
  随机奖励金额已生成: "ランダムな報酬額が生成されました",
  开心收下: "喜んで受け入れます",
  助力已结束: "ヘルプは終了しました",
  助力成功: "成功を助ける",
  成功: "成功",
  进行中: "進行中",
  等待: "待ってください",
  助力失败: "ヘルプに失敗しました",
  任務: "タスク",
  下单失败_请稍后重试:
    "注文に失敗しました。しばらく経ってからやり直してください",
  任务: "タスク"
};
